import { cropPhone } from './cropPhone';
export var getPhoneData = function getPhoneData(_ref) {
  var _data$dynamicCalltrac;
  var data = _ref.data,
    isBuilder = _ref.isBuilder,
    button = _ref.button;
  var defaultType = isBuilder ? 'Застройщик' : 'Агентство недвижимости';
  var defaultButtonText = isBuilder ? 'Контакты застройщика' : 'Контакты представителя';
  return {
    isOpen: data.isOpen,
    realtyUserId: data.realtyUserId,
    phone: data.dynamicPhone || cropPhone({
      phone: data.phone,
      isFullPhone: true
    }),
    name: data.name || '',
    logoUrl: data.avatarUrl || data.logoUrl || '',
    workTime: data.workTime || null,
    type: data.type || defaultType,
    buttonText: data.buttonText || defaultButtonText,
    siteBlockId: (data === null || data === void 0 || (_data$dynamicCalltrac = data.dynamicCalltracking) === null || _data$dynamicCalltrac === void 0 ? void 0 : _data$dynamicCalltrac.siteBlockId) || null,
    button: button ? button : {
      theme: isBuilder ? 'fill_primary' : 'fill_secondary',
      size: 'XS'
    }
  };
};